export const countryList = [
    "Canada",
    "USA"
];